import React, { useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import { Helmet } from 'react-helmet-async'
import Appbar from '../../components/Appbar'
import DrawerUI from '../../components/Drawer'
import { Breadcrumbs, Button, Card, Chip, Paper, Stack, TableContainer, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Link as LinkRRD } from 'react-router-dom'
import { useStyles } from '../../theme/theme'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import Body from '../../layout/Body'
import LoadingUI from '../../comman/LoadingUI'
import NoDataFound from '../../comman/NoDataFound'
import moment from 'moment'

import { publisherUserBlackListStatusChangeAction } from '../../redux/toolkit/publisherUser/blackListPartner'
import { set } from 'lodash'
import SnackBarUI from '../../comman/SnackBarUI'
import { useNavigate } from "react-router-dom";
import { getUserAction } from '../../redux/toolkit/users/getAdminSupports'


const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#fff' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/publisher'>Publisher</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/publisher-user'>Publisher Users</Link>
        </Breadcrumbs >
        <Typography variant='h5'> Black List Partner</Typography>
    </Stack >
)


const BlackListPartner = () => {
    const [pageSize, setPageSize] = useState(25);
    const classes = useStyles();
    const p_user_id = useLocation()?.search?.split("?")[1]
    const location = useLocation();
    const data = location.state; // This contains the params.row data

    const [blackListData, setBlackListData] = useState([])
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [snack, setSnack] = useState(false)

    const updatedBlacklist = useSelector(state => state.publisherUserBlackList)
    const { data: updatedBlacklistData, loading: usersDetailsLoading, status, message } = updatedBlacklist

    const missionDetailsColumn = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            flex: 1,
            minWidth: 50,
            headerClassName: 'super-app-theme--header',
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
        },
        {
            field: 'partner',
            headerName: 'Partner',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',
           
        },

        {
            field: 'status',
            headerName: 'status',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',
           
        },


        {
            field: 'removedAt',
            headerName: 'removedAt',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.removedAt ? moment(params?.row?.removedAt).local().format("DD-MM-YYYY hh:mm:ss A") : '-'}</Typography>

                )
            },
        },

        {
            field: 'changeStatus',
            headerName: 'ChangeStatus',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{Number(params?.row?.status) != 0 ? <Button sx={{ cursor: 'pointer' }} variant="contained" onClick={() => { handleBlackListStatus(params?.row?.partner) }}>Change Status</Button> : '-'}</Typography>

                )
            },
        },

    ]

    

    const handleBlackListStatus = async (partner) => {
        await dispatch(publisherUserBlackListStatusChangeAction({ user_id: data?._id, partner: partner }))
        setSnack(true)
        setTimeout(() => {
            navigate("/user")

        }, 1000)
    }


    useEffect(() => {
        setBlackListData(data?.blockPartnersByAdmin)
    }, [])




    return (
        <>
            <Helmet><title>Real Opinion Admin | Black List Partner</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            <DrawerUI />

            <Body>
                <Card sx={{ mt: 2, }}>
                    <TableContainer sx={{ width: '100%' }}>
                        <Stack direction={'row'} justifyContent='space-between' alignItems={'center'}>
                            <Typography sx={{ ml: 3, my: 2 }} variant='h6'>Black List Partner</Typography>
                        </Stack>

                        <Paper sx={{
                            bgcolor: '#fff',
                            '& .super-app-theme--header': {
                                bgcolor: '#071D45',
                                color: '#fff',
                            },
                        }} elevation={0}>
                            <DataGrid
                                className={classes.root}
                                getRowHeight={() => 'auto'}
                                sx={{ border: 0 }}
                                autoHeight
                                rows={updatedBlacklistData?.length > 0 ? updatedBlacklistData : blackListData}
                                columns={missionDetailsColumn}
                                getRowId={(row) => row._id}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                pagination
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[25, 50, 100]}
                                disableColumnSelector
                                loading={usersDetailsLoading ? <LoadingUI /> : false}
                                components={{
                                    NoRowsOverlay: () => <NoDataFound />,
                                    // Toolbar: GridToolbar,
                                }}

                            />
                        </Paper>
                    </TableContainer>
                </Card>
            </Body>

            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />

        </>
    )
}

export default BlackListPartner
